<template>
  <div class="society-registration">
    <b-container fluid class="user-login ">
      <v-wait :for="loaderId" :visible="loading">
        <template slot="waiting">
          <HalfCircleSpinner />
          <div class="spinner-message my-3 text-center">
            Loading...
          </div>
        </template>
        <template>
          <b-row class="px-3">
            <b-col
              md="6"
              sm="12"
              class="d-flex justify-content-center justify-content-md-start"
            >
              <society-logo v-if="societyLogo" :logo-file="societyLogo" />
            </b-col>
          </b-row>
          <div class="my-5">
            <b-row align-h="center" align-v="center">
              <b-col sm="12">
                <b-card no-body class="max_width_400 w-100 m-auto v2_box_teal">
                  <b-card-header
                    class="user-login__card-header v2_font_size_18 v2_color_black v2_box_teal_header"
                  >
                    Register for Phairify
                  </b-card-header>
                  <b-card-body class="user-login__card-body pt-3">
                    <form @submit.prevent="validateEmail">
                      <b-form-group
                        v-if="society"
                        label="Enter your e-mail address"
                      >
                        <b-form-input
                          type="text"
                          v-model.trim="$v.email.$model"
                          class="p-3 phairify-border-grey height_auto v2_font_size_18 v2_color_black form-control"
                          placeholder="E-mail Address"
                          :state="validateState('email')"
                          @input="onInput"
                        />
                        <div
                          v-show="$v.email.$anyError"
                          tabindex="-1"
                          role="alert"
                          aria-live="assertive"
                          aria-atomic="true"
                          class="invalid-feedback"
                        >
                          {{ emailInvalidFeedback }}
                        </div>
                      </b-form-group>
                      <b-alert :show="!!message" variant="danger">
                        <span v-html="message" />
                      </b-alert>
                      <b-col v-if="society" cols="12" class="text-center">
                        <b-button v-if="isSignInVisible" variant="v2_primary">
                          <router-link to="/login">Sign In</router-link>
                        </b-button>
                        <b-button
                          v-else
                          variant="v2_primary"
                          type="submit"
                          :disabled="validateLoading"
                        >
                          <b-spinner v-if="validateLoading" small />
                          <span v-else>Register</span>
                        </b-button>
                      </b-col>
                    </form>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </template>
      </v-wait>
    </b-container>
  </div>
</template>

<script>
import Api from '@/providers/Api.js';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import SocietyLogo from '@/components/society/SocietyLogo';
import validateStateMixin from '@/mixins/validateStateMixin';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  name: 'SocietyRegistration',
  mixins: [validationMixin, validateStateMixin],
  components: {
    SocietyLogo,
    HalfCircleSpinner,
  },
  data: function () {
    return {
      society: null,
      loading: false,
      email: null,
      message: null,
      validateLoading: false,
      isSignInVisible: false,
    };
  },
  validations: function () {
    return {
      email: {
        required,
        email,
      },
    };
  },
  created: function () {
    this.getData();
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
    societyLogo: function () {
      return this.society ? this.society.logo : null;
    },
    emailInvalidFeedback: function () {
      return !this.$v.email.email
        ? 'Please enter a valid E-mail Address.'
        : 'This field is required';
    },
  },
  methods: {
    getData: async function () {
      this.loading = true;
      try {
        const { urlCode } = this.$route.params;
        this.society = await Api.getSocietyByUrlCode(urlCode);
      } catch (e) {
        if (e.response.status === 404 || e.response.status === 400) {
          this.message = e.response.data.message;
        } else {
          handleServerErrorWithValidation(e, this.$toasted);
        }
      } finally {
        this.loading = false;
      }
    },
    validateEmail: async function () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }
      this.message = null;
      this.validateLoading = true;
      try {
        const token = await Api.validateEmail(this.society.id, this.email);
        if (token) {
          this.$router.push(`/registration/${token}`);
        }
      } catch (e) {
        if (e.response.status === 404 || e.response.status === 400) {
          this.message = e.response.data.message;
          if (e.response.status === 400 && e.response.data.code === 0) {
            this.isSignInVisible = true;
          }
        } else {
          handleServerErrorWithValidation(e, this.$toasted);
        }
      } finally {
        this.validateLoading = false;
      }
    },
    onInput: function () {
      this.isSignInVisible = false;
      this.message = null;
    },
  },
};
</script>

<style scoped/>
